import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { captureUtm } from './services/analytics'
import { applyMaskingFromUrl } from './services/maskMode'
import { initErrorMonitoring, installBenignRejectionGuard } from './services/errorMonitoring'
// Self-hosted variable font (bundled + hashed by Vite; includes latin-ext for č ć ž š đ).
import '@fontsource-variable/plus-jakarta-sans'
import './i18n'
import './index.css'

// Mark the benign camera-teardown play() AbortError as handled (before Sentry,
// so this listener runs first), then start crash reporting.
installBenignRejectionGuard()
initErrorMonitoring()
// First-touch campaign capture from the landing URL, before any lookup runs.
captureUtm()
// ?set_masking=yes|no — recording aid, resolved before the first render so no
// chain name ever flashes unmasked. See services/maskMode.js.
applyMaskingFromUrl()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
